import { de } from '@3pc/lightbox-photoswipe/lib/lang/de';

export const config = {
  mainClass: 'pswp--vdk',
  bgOpacity: 1,
  padding: { top: 100, bottom: 100 },
  closeSVG: `
    <span class="icon icon--cross">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-cross"></use>
      </svg>
      <span class="sr-only">${de.closeTitle}</span>
    </span>
  `,
  zoomSVG: `
    <span class="icon icon--magnifier-plus">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-magnifier-plus"></use>
      </svg>
      <span class="sr-only">${de.zoomTitle}</span>
    </span>
  `,
  arrowPrevSVG: `
    <span class="icon icon--chevron-left-thick">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-chevron-left"></use>
      </svg>
      <span class="sr-only">${de.arrowPrevTitle}</span>
    </span>
  `,
  arrowNextSVG: `
    <span class="icon icon--chevron-right-thick">
      <svg class="icon__svg" role="img" aria-hidden="true">
        <use href="#icon-chevron-right"></use>
      </svg>
      <span class="sr-only">${de.arrowNextTitle}</span>
    </span>
  `,
  preloaderSVG: `
    <div class="spinner">
      <svg class="spinner__icon pswp__icn" viewbox="0 0 66 66" role="img">
        <title>Spinner</title>
        <circle fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
      <span class="sr-only">Inhalte werden geladen ...</span>
    </div>
  `,
  // indexIndicatorSep: '/',
  // Custom props apart from Photoswipe API
  // disableOnClickZoom: true,
  appendUIElementsToBottom: ['counter', 'arrowPrev', 'arrowNext'],
  defaultDialogTitle: 'Galerie Detailansicht',
  showCopyrightUnderCaption: true,
  // alignCopyrightWithImage: true,
};

export const fixCounter = instance => {
  instance.pswpLightboxInstance.on('change', () => {
    const pswp = instance.pswpLightboxInstance.pswp;
    const counter = pswp.element.querySelector('.pswp__counter');
    const counterStr = `<span class="pswp__counter-inner"><span class="pswp__counter-current">${
      pswp.currIndex + 1
    }</span> <span aria-hidden="true">/</span><span class="sr-only">${
      pswp.options.indexIndicatorSep
    }</span> ${pswp.getNumItems()}</span>`;

    counter.classList.add('pswp__counter--has-fix');

    setTimeout(() => {
      counter.innerHTML = counterStr;
    }, 0);
  });
};
